export default "__VITE_ASSET__CR8FOj_i__"